const getters = {
    invoiceCart: state => state.invoiceCart,
    invoiceStatus: state => state.invoiceStatus,
    invoiceErrors: state => state.invoiceErrors,
    paymentStatus: state => state.paymentStatus,
    paymentErrors: state => state.paymentErrors,
    invoices: state => state.invoices,
    invoicesCount: state => state.invoicesCount,
    invoiceDetailById: state => id => {
        return state.invoices.find(invoice => invoice.inv_id === id);
    },
};

export default getters;
